import pathToRegexp from 'path-to-regexp'


const cache = {}

/**
 * Returns link with replaced params
 * @param base string
 * @param params object
 * @return string
 */
const getLinkWithParams = (base: string, params: object = {}): string => {
  const toPath = cache[base] || (cache[base] = pathToRegexp.compile(base))

  return toPath(params)
}


export default getLinkWithParams
